const SSN = Object.freeze({
    RAW_LENGTH: 9,
    MASK: '•••-••-••••',
});

export default SSN;
